"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Sarah Jenkins",
  quote: "BlinkLab Media transformed our online presence. Our new website literally works while we sleep, generating leads 24/7.",
  position: "Founder, Coastal Boutique"
}, {
  author: "Marcus Thorne",
  quote: "The premium design and gold accents perfectly capture our brand's luxury feel. Their SEO strategy has been a game changer.",
  position: "CEO, Thorne Enterprises"
}];
export default function Testimonials() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="245291" id="testimonials" className="bg-background text-foreground relative overflow-hidden ![padding:30px_0px_75px_0px]">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/circuit_pattern.png')] bg-repeat"></div>
      
      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-default">
            What Our Clients Say
          </h2>
          <div className="mt-6 h-1 w-16 bg-primary mx-auto rounded-md shadow-sm shadow-primary/50"></div>
        </div>

        <div className="relative">
          <Carousel setApi={setApi} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                  <div className="flex flex-col items-center text-center px-4 sm:px-12 md:px-24">
                    <Quote className="size-16 text-primary mb-8 opacity-90" />
                    <blockquote className="text-[28px] leading-snug font-serif italic text-foreground/90 mb-10">
                      "{testimonial.quote}"
                    </blockquote>
                    <cite className="not-italic flex flex-col items-center">
                      <span className="font-semibold text-foreground font-default text-lg">
                        {testimonial.author}
                      </span>
                      
                    </cite>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center gap-3 mt-16">
            {Array.from({
            length: count
          }).map((_, index) => <Button key={index} data-index={index} variant="ghost" size="icon" className={cn("size-2.5 rounded-md p-0 transition-all duration-300 hover:bg-primary/80", current === index + 1 ? "bg-primary w-8 shadow-md shadow-primary/20" : "bg-border")} onClick={() => api?.scrollTo(index)} aria-label={`Go to slide ${index + 1}`} />)}
          </div>
        </div>
      </div>
    </section>;
}